import { createFileRoute } from '@tanstack/react-router'
import { JobInfo } from 'pages/jobInfo/JobInfo'
import { z } from 'zod'

const jobSearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
  jobId: z.string().optional(),
})

export const Route = createFileRoute('/job/$siteID')({
  component: JobInfo,
  staticData: {
    title: 'Job Details',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: jobSearchParams,
})
